module.exports = __webpack_public_path__ + "static/media/bristol-laboratories-ltd.a9f4d951.jpg";